import { useQuery } from '@tanstack/react-query'
import { addYears, endOfYear } from 'date-fns'
import { currentUserHolidaysQuery } from 'shared/axios'
import { EARLIEST_DATE, formatDateServer, TODAY } from 'shared/datetime'

const LATEST_DATE = formatDateServer(endOfYear(addYears(TODAY, 1)))

const selectHolidays = (dates: string[]) => dates.map((date) => new Date(date))

export const useGetCurrentUserHolidays = () =>
  useQuery({
    ...currentUserHolidaysQuery(EARLIEST_DATE, LATEST_DATE),
    select: selectHolidays,
  })
